<template>
  <span>
    <v-text-field
      v-model="model"
      :label="label"
      type="number"
    ></v-text-field>
    {{ description }}
  </span>
</template>

<script>
import {
  input
} from '@/mixins/input'
export default {
  mixins: [input],
  data() {
    return {
    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  mounted() {

  },
  methods: {},
}
</script>

<style>

</style>
